import { get } from 'lodash-es';
import { EdmundsAPI } from 'client/data/api/api-client';
import { isCpo } from 'site-modules/shared/utils/inventory-utils/is-cpo';
import { isNew } from 'site-modules/shared/utils/inventory-utils/is-new';
import { INVENTORY_TYPES } from 'client/constants/inventory-types';
import { getMetricsHeaders } from 'client/utils/metrics-header';
import { getIncentivesGQL } from 'site-modules/shared/utils/car-buying/digital-retail-payment-service';
import { getVehicleAge } from 'site-modules/shared/utils/inventory-utils/get-vehicle-age';
import { DEFAULT_VEHICLE } from 'site-modules/calculators/constants/calculators';

export const prepareAPRData = item => [item.termMonths, [{ apr: item.apr }]];

export const getAPRs = async props => {
  const { updatedCreditScore, selectedVehicleStyle, zipCode, headers, term } = props;
  const { year, id: styleId, publicationState: type } = selectedVehicleStyle || DEFAULT_VEHICLE;
  const isNewType = isNew(type);
  const isCPOType = isCpo(type);
  let inventoryCodes;
  if (isNewType) {
    inventoryCodes = INVENTORY_TYPES.NEW;
  } else if (isCPOType) {
    inventoryCodes = INVENTORY_TYPES.CPO;
  }

  let data = [];

  if (isNewType || isCPOType) {
    try {
      const params = {
        zipCode,
        styleId: String(styleId),
        creditScore: updatedCreditScore,
        selectedTerm: term,
        headers,
        inventoryCodes,
      };

      data = await getIncentivesGQL(params);

      return data && Object.fromEntries(data[0].aprs.map(prepareAPRData));
    } catch {
      return data;
    }
  }

  try {
    data = await EdmundsAPI.fetchJson(
      `/usedaprs/v1/?styleId=${styleId}&zipCode=${zipCode}&vehicleAge=${getVehicleAge(
        year
      )}&creditScore=${updatedCreditScore}`,
      {
        headers: getMetricsHeaders('loanAPRsUsed', headers.pageName, headers.venomVersion),
      }
    );

    return data && get(data, 'terms', []);
  } catch {
    return data;
  }
};
